import { api } from './client.js';

const unwrap = (resp) => resp.data?.data;

export const wfApi = {
  // Definitions
  listDefinitions: (params) => api.get('/workflows/definitions', { params }).then(unwrap),
  getDefinition: (id) => api.get(`/workflows/definitions/${id}`).then(unwrap),
  createDefinition: (payload) => api.post('/workflows/definitions', payload).then(unwrap),
  activateDefinition: (id) => api.post(`/workflows/definitions/${id}/activate`).then(unwrap),
  deactivateDefinition: (id) => api.post(`/workflows/definitions/${id}/deactivate`).then(unwrap),

  // Instances
  listInstances: (params) => api.get('/workflows/instances', { params }).then(unwrap),
  getInstance: (id) => api.get(`/workflows/instances/${id}`).then(unwrap),
  getStatusForResource: (resourceType, resourceId) =>
    api.get(`/workflows/resource/${resourceType}/${resourceId}`).then(unwrap),
  myApprovals: () => api.get('/workflows/my-approvals').then(unwrap),
  approve: (stepId, comments) => api.post(`/workflows/instances/${stepId}/approve`, { comments }).then(unwrap),
  reject: (stepId, comments) => api.post(`/workflows/instances/${stepId}/reject`, { comments }).then(unwrap),
  cancel: (instanceId, reason) => api.post(`/workflows/instances/${instanceId}/cancel`, { reason }).then(unwrap),
};
